import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CampaignService {

  env = environment;

  constructor(private readonly http: HttpClient) { }

  getActiveCampaign(utm_id:string,campaignId:string) {
    return this.http.post(this.env.webApiUrl + 'api/Campaign/GetActiveCampaign?utmId='+utm_id+"&campaignId="+campaignId,null);
  }

  setUserCampaign(campaignId:string){
    return this.http.post(this.env.webApiUrl + 'api/Campaign/SetUserCampaign?campaignId='+campaignId,null);
  }
  getUserActiveCampaign(){
    return this.http.get(this.env.webApiUrl + 'api/Campaign/GetUserCampaign');
  }
  getUserAllCampaigns()
  {
    return this.http.get(this.env.webApiUrl + 'api/Campaign/GetUserAllCampaign');
  }
 getCampaignBasedOnParam(data: any)
 {
  return this.http.post(this.env.webApiUrl + 'api/Campaign/GetCampaignBasedOnParam', data);
 }
 getCampaignBannerBind(campaignId:string){
  return this.http.post(this.env.webApiUrl + 'api/Campaign/GetCampaignBannerBind?campaignId='+campaignId, null);
}

}
